export const types = {
  SET_LOCALIZED_STRINGS: 'LOCALIZEDSTRINGS/SET_LOCALIZED_STRINGS',
};

export const initialState = {
  localizedStrings: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const LocalizedStringsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOCALIZED_STRINGS: {
      const { localizedStrings } = action.payload;

      return {
        ...state,
        localizedStrings,
      };
    }
    default: return { ...state };
  }
};

export const actions = {
  setLocalizedStrings: localizedStrings => ({
    type: types.SET_LOCALIZED_STRINGS,
    payload: {
      localizedStrings,
    },
  }),
};

export default LocalizedStringsReducer;
